<script setup>
import {computed, inject, onMounted, ref} from 'vue';
import {useDebug} from '../../../composables/useDebug';
import {useSearchStore} from '../store/useSearchStore';

const {log, error} = useDebug();
const $bus = inject('$bus');

const store = useSearchStore();
const inputRef = ref(null);

const props = defineProps({
    placeholderValue: {
        type: String,
        default: "",
    },
    value: {
        type: String,
        default: null,
    },
    searchType: {
        type: String,
        default: null,
    },
    busy: Boolean,
});

const searchType = computed(() => props.searchType);

const placeholder = computed(() => {
    if (props.placeholderValue === 'search.inputPlaceholder') {
        return $t('search.inputPlaceholder');
    } else {
        return props.placeholderValue;
    }
});

const handleEnter = (value) => {
    $bus.emit('startSearch', store.searchQuery);
};

const handleChange = () => {
    $bus.emit('resetSearch');
};

onMounted(() => {
    if (searchType.value === 'search') {
        $bus.emit('SearchInputRefEmitter', inputRef);
    }
});

</script>

<template>
    <input
        id="search-input"
        class="search-input"
        ref="inputRef"
        v-on:keyup.enter="handleEnter"
        v-on:input="handleChange"
        v-model="store.searchQuery"
        :disabled="props.busy === true"
        :placeholder="placeholder"
        aria-label="Suchen"
    />
</template>
